// Gnb
const gnb = {
	active() {
		const pageUrl = window.location.href;
		const $gnb = $('.app-gnb');

		if (pageUrl.indexOf('pain-about') > -1) {
			$gnb.find('li').eq(0).addClass('is-active');
		} else if (pageUrl.indexOf('pain-management-solution') > -1) {
			$gnb.find('li').eq(1).addClass('is-active');
		} else if (pageUrl.indexOf('pain-daily') > -1) {
			$gnb.find('li').eq(2).addClass('is-active');
		} else if (pageUrl.indexOf('pain-sports') > -1) {
			$gnb.find('li').eq(3).addClass('is-active');
		} else if (pageUrl.indexOf('pain-chronic') > -1) {
			$gnb.find('li').eq(4).addClass('is-active');
		} else if (pageUrl.indexOf('pain-performers-choice') > -1) {
			$gnb.find('li').eq(5).addClass('is-active');
		} else if (pageUrl.indexOf('performers-choice-detail') > -1) {
			$gnb.find('li').eq(5).addClass('is-active');
		}
	},
};
if ($('.app-gnb').length) gnb.active();

// Tab
var tabFocus = 0;
var $tabs = document.querySelectorAll('[role="tab"]');
var $tabList = document.querySelector('[role="tablist"]');
var tabAction = {
	init: function () {
		if (!$tabs.length) return;
		tabAction.click();
		tabAction.keydown();
	},
	click: function () {
		$tabs.forEach(function (e) {
			e.addEventListener('click', tabAction.changeTabs);
		});
	},
	keydown: function () {
		$tabList.addEventListener('keydown', tabAction.changeFocus);
	},
	changeTabs: function (e) {
		var $target = e.currentTarget;
		var $parent = $target.parentNode;
		var $grandparent = $parent.parentNode;

		$parent
			.querySelectorAll('[aria-selected="true"]')
			.forEach(function (i) {
				i.setAttribute('aria-selected', false);
			});

		$target.setAttribute('aria-selected', true);

		if (
			!$grandparent.parentNode.querySelectorAll('[role="tabpanel"]')
				.length
		)
			return;
		$grandparent
			.querySelectorAll('[role="tabpanel"]')
			.forEach(function (i) {
				i.setAttribute('hidden', true);
			});
		$grandparent.parentNode
			.querySelector(`#${$target.getAttribute('aria-controls')}`)
			.removeAttribute('hidden');
	},
	changeFocus: function (e) {
		if (e.keyCode === 39 || e.keyCode === 37) {
			$tabs[tabFocus].setAttribute('tabindex', -1);
			if (e.keyCode === 39) {
				tabFocus++;
				if (tabFocus >= $tabs.length) {
					tabFocus = 0;
				}
			} else if (e.keyCode === 37) {
				tabFocus--;
				if (tabFocus < 0) {
					tabFocus = $tabs.length - 1;
				}
			}
			$tabs[tabFocus].setAttribute('tabindex', 0);
			$tabs[tabFocus].focus();
		}
	},
};

// Modal
const $modal = document.querySelectorAll('[data-modal-name]');
const modal = {
	init() {
		this.handler();
	},
	open: function (v) {
		bodyfixed('hidden');

		$modal.forEach((i) => {
			if (v == i.getAttribute('data-modal-name')) {
				i.classList.add('modal-open');
			}
		});
	},
	close: function (v) {
		bodyfixed('visible');
		if (v === undefined) {
			const $modalVisible = jQuery('[data-modal-name]:visible');
			$modalVisible.removeClass('modal-open');
		} else {
			if (v.type === 'click') {
				const $this = jQuery(v.currentTarget).closest(
					'[data-modal-name]'
				);
				$this.removeClass('modal-open');
			} else {
				const $modal = document.querySelectorAll('[data-modal-name]');
				$modal.forEach((i) => {
					if (v == i.getAttribute('data-modal-name')) {
						i.classList.remove('modal-open');
					}
				});
			}
		}
	},
	handler() {
		$('.modal-trigger-js').on('click', (e) => {
			this.open(
				e.currentTarget.getAttributeNode('data-modal-name').value
			);
		});
		$('.modal-close-button, .modal__close-button-js').on('click', (e) => {
			this.close(e);
		});
	},
};

// Body Fixed
const bodyfixed = (v) => {
	const $html = jQuery('html');
	if (v == 'hidden') {
		$html.addClass('is-modal');
	} else if (v == 'visible') {
		$html.removeClass('is-modal');
	}
};

// Footer Floating
const $appFooter = $('.app-footer');
const $appFooterFloat = $appFooter.find('.app-footer-float-wrapper');
const $floatingTopButton = $appFooterFloat.find(
	'.app-footer-float__top-button'
);
const floatingAction = {
	init() {
		gsap.set($appFooterFloat, { alpha: 0 });
		$appFooterFloat.addClass('is-invisible');
		this.handler();
	},
	handler() {
		$floatingTopButton.on('click', () => this.click());
		window.addEventListener('scroll', (e) => this.scroll(e));
	},
	click() {
		gsap.to('html, body', { scrollTop: 0 });
	},
	scroll(e) {
		const _this = $(e.currentTarget);
		const _windowHeight = window.innerHeight;
		const appFooterFloatBreak =
			$appFooter.offset().top - window.innerHeight;
		let offsetY = window.pageYOffset;

		if (offsetY >= _windowHeight / 3) {
			gsap.to($appFooterFloat, { alpha: 1 });
			$appFooterFloat.removeClass('is-invisible').addClass('is-visible');
		} else {
			gsap.to($appFooterFloat, { alpha: 0 });
			$appFooterFloat.removeClass('is-visible').addClass('is-invisible');
		}

		if (offsetY >= appFooterFloatBreak) {
			$appFooterFloat.addClass('is-break');
		} else {
			$appFooterFloat.removeClass('is-break');
		}
	},
};
if ($floatingTopButton.length) floatingAction.init();

// Target Scroll
const targetScroll = {
	scroll() {
		const $offsetTarget = $('.offset-target');

		if (!$offsetTarget.length) return;

		let offsetY = window.pageYOffset;

		$offsetTarget.each((i, v) => {
			let $this = $(v);
			let triggerStart =
				$this.offset().top -
				window.innerHeight +
				$this.outerHeight(true);
			// let triggerEnd = $this.offset().top;

			if (offsetY >= triggerStart) {
				$this.addClass('is-screen-enter');
			} else {
				$this.removeClass('is-screen-enter');
			}
		});
	},
};
targetScroll.scroll();

// Scroll Spy
let spyIdx;
const scrollSpy = {
	init() {
		this.handler();
	},
	handler() {
		$('.scroll-spy-js').on('click', '.distinction__indicator-tab', (e) => {
			this.click(e);
		});
	},
	click(e) {
		const $this = $(e.currentTarget);
		const idx = $this.index();
		const $spySection = $('[data-spy-section]');
		const pageY = $spySection.eq(idx).offset().top - 214;

		gsap.to('html, body', {
			duration: 0.4,
			scrollTop: pageY,
		});
	},
	scroll() {
		if (!$('.scroll-spy-js').length) return;

		let st = window.pageYOffset;
		// let spyIdx;
		const $spySection = $('[data-spy-section]');

		if (st <= $spySection.eq(0).offset().top) {
			spyIdx = $spySection.length;
			$('.distinction__indicator-tab').removeClass('is-active');
		}

		let tabH = $('.app-header').outerHeight(true) + 100;
		$spySection.each((i) => {
			if (
				st >= $spySection.eq(i).offset().top - tabH &&
				st <
					$spySection.eq(i).offset().top +
						$spySection.outerHeight(true) -
						tabH
			) {
				spyIdx = i;
			} else if (st <= $spySection.eq(0).offset().top) {
				spyIdx = 0;
			}
		});

		$('.scroll-spy-js')
			.find('.distinction__indicator-tab')
			.eq(spyIdx)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	},
};

// Guidelines
const guidelines = {
	handler() {
		$('.guidelines-tabs').on('click', '.guidelines-tab', function () {
			let _this = $(this);
			let idx = _this.index();
			let headerH = $('.app-header').outerHeight(true);
			let moveY =
				$('.guidelines-tabs').eq(idx).offset().top - headerH + 1;
			gsap.to('html, body', { scrollTop: moveY });
		});
	},
};

// Reference
const reference = {
	handler() {
		$('.reference-button').on('click', (e) => {
			let _this = $(e.currentTarget);

			if (_this.parent().hasClass('is-active')) {
				_this.parent().removeClass('is-active');
			} else {
				_this.parent().addClass('is-active');
			}
		});
	},
};

// pcs
let isPcs = false;
let isPcsInit = false;
let mbpcInterval;
const pcs = {
	init() {
		if ($('.pcs__step').length) {
			const $wrapper = $('.pcs__step');
			const autoplayDuration = $wrapper.data('autoplay-duration');
			let idx = Number($wrapper.attr('data-idx'));

			$wrapper
				.find('.pcs__item')
				.eq(idx - 1)
				.addClass('is-active');
			pcs.handler();
		}
	},
	next(v) {
		let nextIdx;
		const $wrapper = $('.pcs__step');
		const itemLen = $('.pcs__item').length;
		let idx = Number($wrapper.attr('data-idx'));

		if (idx === itemLen) {
			$wrapper.attr('data-idx', 1);
			$wrapper
				.find('.pcs__item')
				.eq(0)
				.addClass('is-active')
				.siblings()
				.removeClass('is-active');
		} else {
			$wrapper.attr('data-idx', idx + 1);
			$wrapper
				.find('.pcs__item')
				.eq(idx)
				.addClass('is-active')
				.siblings()
				.removeClass('is-active');
		}
	},
	play() {
		const $wrapper = $('.pcs__step');
		const autoplayDuration = $wrapper.data('autoplay-duration');

		$('.pcs__step').attr('data-autoplay', true);
		mbpcInterval = setInterval(pcs.next, autoplayDuration);
	},
	pause() {
		clearInterval(mbpcInterval);
		$('.pcs__step').attr('data-autoplay', false);
	},
	change: function (i) {
		const $wrapper = $('.pcs__step');
		$wrapper.attr('data-idx', i + 1);
		$wrapper
			.find('.pcs__item')
			.eq(i)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	},
	scroll: function () {
		if (!$('.pcs__step').length) return;
		if (isPcs) return;

		const $el = $('.pcs__step');
		var $target = $el.offset().top;
		var winH = window.innerHeight;
		var pageY = window.pageYOffset;

		if (pageY >= $target - winH + $el.outerHeight()) {
			if (!isPcsInit) {
				isPcsInit = true;
				isPcs = true;
				pcs.init();
				pcs.play();
			}
		}
	},
	handler: function () {
		$('.pcs__item')
			.on('mouseenter', function (e) {
				let idx = $(this).index();
				pcs.pause();
				pcs.change(idx);
			})
			.on('mouseleave', function () {
				pcs.play();
			});
	},
};

// Social
const social = {
	init() {
		$(document).on('click', function (e) {
			if (e.target.className == 'click') {
				return false;
			}
			$('.social').removeClass('is-active');
		});
		this.handler();
	},
	handler() {
		$('.el-header__share-button, .psc-share-button').on('click', (e) => {
			e.stopPropagation();
			let _this = $(e.currentTarget);
			_this.parent().toggleClass('is-active');
		});
	},
};

// Performer’s Choice
let pscSwiper;
const psc = {
	swiper() {
		const pscSwiper = new Swiper('.psc-swiper', {
			slidesPerView: 3,
			spaceBetween: 20,
			// loop: true,
			// Navigation arrows
			navigation: {
				nextEl: '.psc-swiper-button-next',
				prevEl: '.psc-swiper-button-prev',
			},
			// And if we need scrollbar
			scrollbar: {
				el: '.psc-swiper-scrollbar',
			},
		});
	},
};

// EvenListener
window.addEventListener('DOMContentLoaded', function () {
	tabAction.init();
	modal.init();
	psc.swiper();
	social.init();
});
window.addEventListener('scroll', function (e) {
	floatingAction.scroll(e);
	targetScroll.scroll();
	scrollSpy.scroll();
	pcs.scroll();
});

// Init
const initFn = () => {
	scrollSpy.init();
	guidelines.handler();
	reference.handler();
};

// IIFE
(() => {
	initFn();
})();
